<template>
  <div>
    <!-- <div class="swiper" style="height: 256px">
      <div
        class="swiper-container-top"
        id="swiper"
        style="width: 100%; height: 256px; overflow: hidden"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            style="width: 100%"
            v-for="(item, index) in imgList"
            :key="index"
          >
            <img class="w-h-100" :src="item.url" />
          </div>
        </div> -->
        <!-- 如果需要分页器 -->
        <!-- <div class="swiper-pagination-top"></div> -->
        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div> -->
      <!-- </div> -->
    <!-- </div> -->
    <div>
      <swiper-news></swiper-news>
    </div>
    <div class="flex just-between" style="margin: 20px auto">
      <div class="cursor-pointer" @click="gotoLink(item)" style="width: 30%; height: 108px" v-for="(item, index) in imageList" :key="index">
        <img class="w-h-100" :src="item.attachment.url" alt="" />
      </div>
    </div>
    <div class="flex just-between flex-wrap">
      <div style="width: 30%" v-for="(item, index) in contentList" :key="index">
        <list-component :listData="item"></list-component>
      </div>
    </div>
    <div id="service">
      <div
        class="flex just-center align-center"
        style="padding-bottom: 10px; border-bottom: 1px solid #d5d5d5"
      >
        <div style="width: 26px; height: 26px; margin-right: 10px">
          <img class="w-h-100" src="../assets/image/fw.png" alt="" />
        </div>
        <div class="font-bold" style="font-size: 20px; color: #76040b">
          服务中心
        </div>
      </div>
      <div class="flex" style="padding: 20px 0">
        <div
          style="
            width: 318px;
            background: #650004;
            color: #fff;
            min-height: 422px;
            margin-right: 20px;
          "
        >
          <div class="flex" style="padding: 20px; border-bottom: 1px solid #fff;">
            <div style="width: 16px; height: 16px; margin-right: 10px">
              <img class="w-h-100" src="../assets/image/rlzy.png" alt="" />
            </div>
            <div style="font-size: 16px" v-if="rootDeptDuty">{{ rootDeptDuty.deptName }}</div>
          </div>
          <div style="padding: 20px">
            <div class="intro-new" v-if="rootDeptDuty">{{ rootDeptDuty.profile }}</div>
          </div>
          <div style="padding: 0 20px">
            <div
              style="height: 40px; padding: 10px 0"
              v-for="(item, index) in deptDutyList"
              :key="index"
            >
              <div style="border-left: 3px solid #fff; padding-left: 10px"
              @click="handleDutyClick(item.linkUrl)"
              class="cursor-pointer"
              >
                {{ item.deptName }}
              </div>
            </div>
          </div>
        </div>
        <div style="flex: 1">
          <div class="flex just-between flex-wrap">
            <service-center-box
              v-for="(item, index) in deptDutyList"
              :key="index"
              :deptDuty="item"
            ></service-center-box>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "../../node_modules/swiper/dist/css/swiper.css";
import swiperNews from "../components/swiperNews";
import listComponent from "../components/listComponent";
import serviceCenterBox from "../components/serviceCenterBox";
export default {
  components: {
    swiperNews,
    listComponent,
    serviceCenterBox,
  },
  data() {
    return {
      title: "",
      imageList: [],
      introduce: "",
      rootDeptDuty: {},
      deptDutyList: [],
      newsNotice: {},
      // imgList: [
      //   {
      //     url: require("../assets/image/2.png"),
      //   },
      //   {
      //     url: require("../assets/image/2.png"),
      //   },
      //   {
      //     url: require("../assets/image/2.png"),
      //   },
      // ],
      contentList: [],
    };
  },
  methods: {
    handleDutyClick (url) {
      if (url) {
        window.open(url);
      }
    },
    getTitleList() {
      this.$api.index.getCatalog().then((res) => {
        if (res.code === 200) {
          this.contentList = res.data.filter(
            (category) => {
              if (category.name === '新闻通知') {
                this.newsNotice = category;
              }
              return category.homeDisplay === 1 && category.name !== '新闻通知' && !category.hyperlink
            }
          );
        }
      });
    },
    // swiperStart() {
    //   const swiper = new Swiper(".swiper-container-top", {
    //     slidesPerView: 1,
    //     autoplay: true,
    //     speed: 1000,
    //     loop: true,
    //     pagination: {
    //       el: ".swiper-pagination-top",
    //       type: "custom",
    //       clickable: true,
    //       renderCustom: (swiper, current, total) => {
    //         let paginationHtml = " ";
    //         for (let i = 0; i < total; i++) {
    //           // 判断是不是激活焦点，是的话添加active类，不是就只添加基本样式类
    //           if (i === current - 1) {
    //             paginationHtml += `
    //                             <span style="color:#fff;float:left;padding-left:10px;">
    //                                 <span style="color:red;display:inline-block;position: relative;top: -11px;">[${this.imgList[i].categoryName}]</span>
    //                                 <span style="display:inline-block;width:260px;white-space: nowrap;text-align:left;text-overflow: ellipsis;overflow: hidden;">${this.imgList[i].title}</span>
    //                             </span>
    //                             <span class="swiper-pagination-customs swiper-pagination-customs-active" ></span>`;
    //           } else {
    //             paginationHtml +=
    //               '<span class="swiper-pagination-customs" ></span>';
    //           }
    //         }
    //         return paginationHtml;
    //       },
    //     },
    //   });
    // },
    gotoLink (item) {
      if (item.url) {
        const a = document.createElement("a");
        let url = "";
        if (item.url.indexOf("http") !== -1) {
          url = item.url;
        } else {
          url = "http://" + item.url;
        }
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        a.click();
      }
    },
    gotoService() {
      const obj = document.createElement("a");
      obj.href = "#service";
      obj.click();
    },
    getImageList () {
      this.$api.website.getImageList().then(res => {
        if (res.code === 200) {
          this.imageList = res.data.content
        }
      })
    },
    getServiceInfo() {
      this.$api.index.getServiceInfo().then((res) => {
        if (res.code === 200) {
          this.title = res.data.title;
          this.introduce = res.data.introduce;
        }
      });
    },
    getDeptDutyList() {
      this.$api.index.getDeptDutyList().then((res) => {
        if (res.code === 200) {
          this.deptDutyList = res.data.filter((d) => !d.root);
          this.rootDeptDuty = res.data.filter((d) => d.root)[0];
        }
      });
    },
  },
  mounted() {
    this.getImageList()
    this.getTitleList();
    // this.swiperStart();
    this.getServiceInfo();
    this.getDeptDutyList();
  },
};
</script>

<style scoped lang='less'>
.line-height-50 {
  width: 116.1818px;
  text-align: center;
  cursor: pointer;
  padding: 17px 0;
}
// ul li .border-right{
//     border-right: 1px solid #fff;
// }
// ul li:last-child .border-right{
//     border-right: none;
// }
.active-class {
  background: #c81520;
}
.active-class .border-right {
  border: none;
}
.date-class {
  width: 86px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #fff;
  margin-right: 10px;
  text-align: center;
}
.intro-new {
  overflow: hidden;
  font-size: 14px;
  line-height: 24px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
